import type {
  StayGuestHospitalityCategory,
  StayPlaybookTemplateKey,
} from "./stayData"

export type HospitalityCategoryOption = {
  label: string
  playbookKey: StayPlaybookTemplateKey
  value: StayGuestHospitalityCategory
}

export const hospitalityCategoryOptions = [
  {
    label: "Food & Drink",
    playbookKey: "hospitality_food_and_drink",
    value: "food_and_drink",
  },
  {
    label: "Guiding",
    playbookKey: "guiding_notes",
    value: "guiding",
  },
  {
    label: "Hosting",
    playbookKey: "hosting_notes",
    value: "hosting",
  },
  {
    label: "Other",
    playbookKey: "hospitality_other",
    value: "other_hospitality",
  },
] satisfies readonly HospitalityCategoryOption[]
